import React from 'react';
import { Divider } from '@roo/roo';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { savePersonInfo } from '@assets/apis/scientist';
import Personal from './personal';
import Education from './education';
import Research from './research';
import { cols } from '../../_utils/config';
import { useSimpleContext } from '../../_context';
import { FormHok } from '../../_components/FormHok';

const Root = styled.div`
  .form-patch {
    margin-top: 8px;
    width: 634px;
  }
  .form-group {
    & > label {
      text-align: left;
    }
  }
  .field-upload {
    margin-left: 12px;
  }
  .boffin {
    position: relative;
    .delete {
      position: absolute;
      top: -10px;
      right: 100px;
    }
  }
`;

// 附加信息
const PersonInfo = function () {
  const { state } = useSimpleContext((t) => [t.scientist.iniValues, t.disabled]);
  const iniData = state.scientist.iniValues?.personInfo;

  const formatPersonInfo = (val) => {
    (val.eduInfo || []).forEach((item) => {
      if (item.endTime === dayjs().format('YYYY-MM-DD')) {
        item.endTime = '至今';
      }
    });
    (val.workInfo || []).forEach((item) => {
      if (item.endTime === dayjs().format('YYYY-MM-DD')) {
        item.endTime = '至今';
      }
    });
    return val;
  };

  return (
    <FormHok
      value={iniData}
      cols={cols}
      disabled={state.disabled}
      alwaysUpdate={false}
      handleSave={(v) => {
        const personInfo = formatPersonInfo(v);
        return savePersonInfo(personInfo);
      }}
    >
      {(props) => (
        <Root className="boffin">
          <div className="form-title">
            个人信息
            <Divider />
          </div>
          <Personal {...props} />
          <div className="form-title">
            教育经历
            <span>请按时间倒序填写至本科阶段</span>
            <Divider />
          </div>
          <Education {...props} />
          <div className="form-title">
            科研工作经历
            <Divider />
          </div>
          <Research {...props} />
          <br />
        </Root>
      )}
    </FormHok>
  );
};

export default PersonInfo;
